import React, { useRef } from 'react';
import c from './icons-menu.module.scss';
import { Button } from '@monash/portal-react';
import {
  AppIcons,
  isUrl,
  useOnOutsideClick,
} from '@monash/portal-frontend-common';
import {
  FloatingPortal,
  useFloating,
  offset,
  flip,
  shift,
} from '@floating-ui/react';

import emojis from './emoji.json';
import ShortcutIconButton from '../../shortcut-icon-button/ShortcutIconButton';

const IconsMenu = ({
  isShown,
  setIsShown,
  triggerRef,
  iconInput,
  urlInput: inputUrl,
  setIconInput,
}) => {
  const menuRef = useRef();
  const hasValidInputUrl = isUrl(inputUrl);

  const { refs, floatingStyles } = useFloating({
    elements: {
      reference: triggerRef.current,
    },
    placement: 'bottom-start',
    middleware: [offset({ crossAxis: 44 }), flip(), shift()],
  });

  useOnOutsideClick({
    refs: [triggerRef, menuRef],
    fn: () => setIsShown(false),
  });

  const updateIconInput = (iconData) => {
    setIconInput(iconData);
    setIsShown(false);
  };

  return (
    <>
      {isShown && (
        <FloatingPortal>
          <div
            ref={(node) => {
              refs.setFloating(node);
              menuRef.current = node;
            }}
            style={{ ...floatingStyles, zIndex: 100 }}
            role="dialog"
            aria-modal="true"
            aria-label="icons"
          >
            <div className={c.iconMenu}>
              <div className={c.iconGroups}>
                {hasValidInputUrl && (
                  <div className={c.iconGroup}>
                    <label>Favicon</label>

                    <div className={c.icons}>
                      <ShortcutIconButton
                        iconData={{
                          type: 'favicon',
                          app: 'Monash Logo',
                        }}
                        inputUrl={inputUrl}
                        selectedIcon={iconInput}
                        onClick={updateIconInput}
                      />
                    </div>
                  </div>
                )}

                <div className={c.iconGroup}>
                  <label>Icons</label>

                  <div className={c.icons}>
                    {Object.keys(AppIcons).map((app) => (
                      <ShortcutIconButton
                        iconData={{
                          type: 'appIcon',
                          app,
                        }}
                        inputUrl={inputUrl}
                        selectedIcon={iconInput}
                        onClick={updateIconInput}
                        key={app.app}
                      />
                    ))}
                  </div>
                </div>
                <div className={c.iconGroup}>
                  <label>Emojis</label>

                  <div className={c.icons}>
                    {emojis.map((emoji) => (
                      <ShortcutIconButton
                        iconData={{
                          type: 'emoji',
                          character: emoji.character,
                        }}
                        inputUrl={inputUrl}
                        selectedIcon={iconInput}
                        onClick={updateIconInput}
                        key={emoji.character}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <div className={c.actions}>
                <Button
                  variant="text"
                  size="small"
                  onClick={() => updateIconInput(null)}
                >
                  Discard
                </Button>
              </div>
            </div>
          </div>
        </FloatingPortal>
      )}
    </>
  );
};

export default IconsMenu;
